<template>
  <div class="create-system">
    <div class="breadcrumb" style="background: #fff">{{ $route.query.type === 'check' ? '查看SKU组' : '审核SKU组' }}</div>
    <div class="third-title">SKU组基础信息</div>
    <div class="order-detail-basic">
      <el-form :model="skuList" label-width="130px">
        <el-form-item label="SKU组名称:">
          <span>{{ skuVo.skuGroupName }}</span>
        </el-form-item>
        <el-form-item label="SKU组图片:">
          <div id="show_img" style="width: 100%;" v-if="skuVo.skuGroupImage">
            <img :src="skuVo.skuGroupImage" alt="" style="max-width: 200px;float: left">
          </div>
        </el-form-item>
        <div class="third-title" style="margin-left: 0;margin-bottom: 20px;">SKU组详细信息</div>
        <el-form-item label="套系内SKU组合:">
          <el-tag v-for="(tag) in tags" :key="tag.skuName" :disable-transitions="false" type="info"> {{ tag.skuName }}</el-tag>
        </el-form-item>
        <div style="display: flex;">
          <el-form-item :label="$route.query.spuProperty === 'NORMAL' ? '平台价格' : '基础P平台价格:'">
            <span>{{ skuVo.skuList[0].basePagePrice }}</span>
          </el-form-item>
          <el-form-item label="积分价格" v-if="$route.query.showPoint == 'true'">
            <span>{{ skuVo.skuList[0].basePagePoints }}</span>
          </el-form-item>
        </div>
        <el-form-item label="在线支付价格:">
          <span>{{ skuVo.skuList[0].onlineSalePrice }}</span>
        </el-form-item>
        <el-form-item label="初创平台价格:" v-if="$route.query.startupsSpu == 'true'">
          <span style="display:inline-block;width:200px;">{{ skuVo.skuList[0].startupsBasePagePrice }}</span>
        </el-form-item>
        <el-form-item label="推荐终端价格:">
          <span>{{ skuVo.skuList[0].salePrice }}</span>
        </el-form-item>
        <el-form-item label="通货编码:" v-if="$route.query.spuProperty === 'NORMAL'">
          <span>{{ skuVo.skuList[0].sampleBarCode }}</span>
        </el-form-item>
        <el-form-item label="样品价格:" v-if="$route.query.spuProperty !== 'NORMAL'">
          <span style="display:inline-block;width:200px;">{{ skuVo.samplePrice }}</span>
        </el-form-item>
        <el-form-item label="样品积分价格:" v-if="$route.query.spuProperty !== 'NORMAL' && $route.query.showPoint == 'true'">
          <span style="display:inline-block;width:200px;">{{ skuVo.samplePoints }}</span>
        </el-form-item>
        <el-form-item label="在线支付样品价格:" v-if="$route.query.spuProperty !== 'NORMAL'">
          <span style="display:inline-block;width:200px;">{{ skuVo.onlineSamplePrice }}</span>
        </el-form-item>
        <el-form-item label="初创平台样品价格:" v-if="$route.query.spuProperty !== 'NORMAL' && $route.query.startupsSpu == 'true'">
          <span style="display:inline-block;width:200px;">{{ skuVo.startupsSamplePrice }}</span>
        </el-form-item>
        <el-form-item label="样品主题:" v-if="$route.query.spuProperty !== 'NORMAL'">
          <el-table :data="skuTransferMsg.sampleTableData" style="width: 400px" border>
            <el-table-column label="样品编码" min-width="200px" prop="sampleBarCode"></el-table-column>
            <el-table-column label="主题" min-width="100px" prop="themeName"></el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="库存:"> {{ skuVo.stockCount }} </el-form-item>
        <el-form-item label="有效期:" v-if="skuVo.isTimeLimit"> {{ skuVo.timeLimitStartTime + ' 到 ' + skuVo.timeLimitEndTime }} </el-form-item>
      </el-form>
    </div>
    <div class="edit-button">
      <el-button round @click="$router.go(-1)" v-if="$route.query.type === 'check'" type="primary">确定</el-button>
      <el-button round @click="checkStatus = 'AUDIT_FAIL', checkDialog = true" v-if="$route.query.type === 'audit'" type="primary">审核拒绝</el-button>
      <el-button round @click="checkStatus = 'AUDIT_SUCCESS', checkDialog = true" v-if="$route.query.type === 'audit'" type="primary">审核通过</el-button>
    </div>
    <!-- 查看尺寸组 -->
    <el-dialog :close-on-click-modal="false" width="800px" title="尺寸组" :visible.sync="sizeGroupDialog">
      <el-table :data="checkSizeGroupTableData" border>
        <el-table-column type="expand">
          <template v-slot='scope'>
            <div style="width:100%;height:100%;background:red">
              <el-table :data="scope.row.sizeList" border>
                <el-table-column label="尺寸名称" prop="sizeName"></el-table-column>
                <el-table-column label="页面类型" prop="typeName"></el-table-column>
                <el-table-column label="页面名称" prop="pageName"></el-table-column>
                <el-table-column label="宽高">
                  <template slot-scope="scope"> {{ scope.row.sizeWidth }}*{{ scope.row.sizeHeight }}mm </template>
                </el-table-column>
                <el-table-column label="出血类型" prop="bleed.bleedName"></el-table-column>
                <el-table-column label="出血" width="220px">
                  <template slot-scope="scope"> 上：{{ scope.row.bleed.bleedTop }}mm 底部：{{ scope.row.bleed.bleedBottom }}mm<br> 内侧：{{ scope.row.bleed.bleedIn }}mm 外侧：{{ scope.row.bleed.bleedOut }}mm
                  </template>
                </el-table-column>
                <el-table-column label="码" prop="barCodeId"></el-table-column>
              </el-table>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="尺寸组名称" min-width="100px" prop="groupName"></el-table-column>
        <el-table-column label="尺寸组类" prop="composeSizeGroupCategory.categoryName" min-width="100px"></el-table-column>
        <el-table-column label="页面名称" prop="pageName" min-width="100px"></el-table-column>
      </el-table>
    </el-dialog>
    <!-- 审核 -->
    <el-dialog :close-on-click-modal="false" title="重要提示" :visible.sync="checkDialog" width="30%">
      <span>是否确认{{ checkStatus === 'AUDIT_SUCCESS' ? '审核通过' : '审核拒绝' }}？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="check(checkStatus)">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { sampleListNoPaging, skuSpecialStoreList, skuGroupUpdateSeries, updateSeriesCurrency, skuSampleDelete, skuSampleSave, composeGroupDetail, skuGroupAudit, spuList, skuGroupDetail, skuGroupSeriesAdd, skuGroupListBySpuId, skuList } from '@/api/pms'
export default {
  name: 'createSystemSKU',
  data () {
    return {
      awsSdk: null,
      specialStoreList: [],
      isEditSamplePrice: false,
      checkStatus: '',
      checkDialog: false,
      selectSpuId: '',
      sizeGroupDialog: false,
      checkSizeGroupTableData: [],
      skuVo: {
        skuList: [{}],
        samplePrice: '',
        sampleThemeIdSet: [],
        skuGroupImage: '',
        skuGroupName: '',
        spuId: +this.$route.query.spuId
      },
      skuTransferMsg: {
        sampleItem: '',
        sampleList: [],
        sampleTableData: []
      },
      treeData: '',
      treeDataValue: '',
      skuList: {
        skuName: '',
        imgSrc: '',
        proType: '',
        product: '',
        skuGroup: '',
        skuSystem: [],
        price: '',
        samplePrice: '',
        theme: '',
        type: '',
        sampleTheme: '',
        addSampleTheme: []
      },
      options: [],
      tableData: [],
      tags: [],
      spuQueryInfo: {
        pageNum: 1,
        pageSize: 100
      },
      spuList: [],
      skuGroupListBySpuId: []
    }
  },
  created () {
    this.getSkuGroupMsg()
  },
  methods: {
    // 审核
    check (status) {
      if (status === 'AUDIT_SUCCESS') {

      }
      skuGroupAudit({ skuGroupId: this.$route.query.id, status }).then(res => {
        if (res.data.success) {
          this.$message.success(status === 'AUDIT_SUCCESS' ? '审核通过' : '审核拒绝')
          this.checkDialog = false
          this.$router.go(-1)
        }
      })
    },
    // 获取sku组详情
    getSkuGroupMsg () {
      skuGroupDetail(this.$route.query.id).then(res => {
        if (res.data.success) {
          this.skuVo = res.data.data
          this.tags = res.data.data.skuList[0].seriesAssociateSkuList
          this.skuTransferMsg.sampleTableData = res.data.data.sampleThemeList
        }
      })
      if (this.$hasPermission('pms:admin:special:store:list')) {
        // 获取特殊价格加盟店列表
        skuSpecialStoreList(this.$route.query.id).then(res => {
          if (res.data.success) {
            this.specialStoreList = res.data.data.data
          }
        })
      }
    },
    // 查看尺寸组
    checkSizeGroup (row) {
      composeGroupDetail(row.composeSizeGroupId).then(res => {
        if (res.data.success) {
          this.checkSizeGroupTableData = [res.data.data]
        }
      })
      this.sizeGroupDialog = true
    },
    rowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },
    handleClose (val, index) {
      this.tags.splice(index, 1)
    },
    RowClassName ({ row, rowIndex }) {
      row.index = rowIndex
    },
    addSKUGroup (val) {
      this.tags.push(val)
    }
  }
}
</script>
<style scoped lang="less">
@import "styles";
@deep: ~">>>";
</style>
